'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.isLoadTime = isLoadTime;
exports.getLoaderKey = getLoaderKey;
exports.getLoaderState = getLoaderState;

var _TypeCast = require('helpers/TypeCast');

var _strings = require('helpers/strings');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _datetime = require('helpers/datetime');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create default reducer for API request with (example for user module)
 *
 * createLoadReducer('auth', {<name>: params})
 *
 * name - action name
 * params.action - string, optional: prefix for constants
 * params.init - any, optional: initial state
 * params.keepOnLoad - boolean: keep old data while performing a new request
 * params.loaderKeys - array: array of field names of action object for set unique loading keys for each request
 * params.field - string|array - field name in response to use as data source
 *
 * createLoadReducer('auth', {user: {action: 'load', init: {data: []}}})
 * will generate
 *
 * constants:
 * LOAD_USER = 'auth/LOAD_USER'
 * LOAD_USER_SUCCESS = 'auth/LOAD_USER_SUCCESS'
 * LOAD_USER_FAIL = 'auth/LOAD_USER_FAIL'
 *
 * initialState:
 * userData: []
 * userActionData: {}
 * userLoading: false
 * userLoaded: false
 * userLoadError: null
 *
 * appropriate reducer actions
 *
 */

function getKey(mappedKey, objKey) {
  return '' + mappedKey + (0, _strings.capitalize)(objKey);
}

function mapToKey(mappedKey, obj) {
  var res = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(obj)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
          key = _step$value[0],
          val = _step$value[1];

      //eslint-disable-line no-restricted-syntax
      res[getKey(mappedKey, key)] = val;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return res;
}

function isLoadTime(_ref) {
  var _ref$useCache = _ref.useCache,
      useCache = _ref$useCache === undefined ? true : _ref$useCache,
      key = _ref.key,
      state = _ref.state,
      cacheTime = _ref.cacheTime;

  if (!useCache) {
    return true;
  }
  var loaded = state[key + 'Loaded'],
      loading = state[key + 'Loading'],
      time = state[key + 'Timestamp'];

  return !(loading || loaded && !(0, _datetime.isExpired)({ time: time, duration: cacheTime }));
}

function getActionKeys(key, opts) {
  var constKey = (0, _strings.toUpperUnderscore)(key);
  var constAction = typeof opts.action === 'undefined' ? '' : opts.action.toUpperCase() + '_';
  var actionKey = constAction + constKey;
  var actionKeySuccess = '' + constAction + constKey + '_SUCCESS';
  var actionKeyFail = '' + constAction + constKey + '_FAIL';

  return { actionKey: actionKey, actionKeySuccess: actionKeySuccess, actionKeyFail: actionKeyFail };
}

function getInitial(module, keys) {
  var constants = {};
  var constantsByKey = {};
  var initialState = {};

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(keys)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
          key = _step2$value[0],
          opts = _step2$value[1];

      //eslint-disable-line no-restricted-syntax
      var _getActionKeys = getActionKeys(key, opts),
          actionKey = _getActionKeys.actionKey,
          actionKeySuccess = _getActionKeys.actionKeySuccess,
          actionKeyFail = _getActionKeys.actionKeyFail;

      constants[actionKey] = module + '/' + actionKey;
      constants[actionKeySuccess] = module + '/' + actionKeySuccess;
      constants[actionKeyFail] = module + '/' + actionKeyFail;
      constants[key] = {
        start: constants[actionKey],
        success: constants[actionKeySuccess],
        fail: constants[actionKeyFail]
      };

      constantsByKey[key] = [constants[actionKey], constants[actionKeySuccess], constants[actionKeyFail]];

      (0, _assign2.default)(initialState, mapToKey(key, {
        data: opts.init,
        actionData: {},
        loading: false,
        loaded: false,
        loadError: null,
        loaders: {}
      }));
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return { constants: constants, constantsByKey: constantsByKey, initialState: initialState };
}

function formatField(field) {
  var formattedField = [];
  if (typeof field === 'string') {
    formattedField = field.split('.');
  } else if (typeof field === 'number') {
    formattedField.push(field);
  } else if (field instanceof Array) {
    formattedField = field;
  }

  return formattedField;
}

function setStateData(state, stateData, key) {
  return (0, _extends4.default)({}, state, mapToKey(key, stateData));
}

function getLoaderKey(parts) {
  var key = 'lid';
  parts.map(function (part) {
    return key += '_' + part;
  }); //eslint-disable-line no-return-assign
  return key;
}

function getLoaderState(_ref2) {
  var loader = _ref2.loader,
      keys = _ref2.keys;

  var loaderKey = getLoaderKey(keys);
  return loader[loaderKey];
}

function getLoaderKeyFromAction(loaderKeys, action) {
  var keyParts = loaderKeys.map(function (loaderKey) {
    return action[loaderKey];
  });
  return getLoaderKey(keyParts);
}

function updateLoaders(_ref3) {
  var state = _ref3.state,
      stateData = _ref3.stateData,
      key = _ref3.key,
      opts = _ref3.opts,
      action = _ref3.action,
      value = _ref3.value;

  if (opts.loaderKeys) {
    if (value) {
      stateData.loaders = (0, _extends4.default)({}, state[getKey(key, 'loaders')], (0, _defineProperty3.default)({}, getLoaderKeyFromAction(opts.loaderKeys, action), value));
    } else {
      stateData.loaders = (0, _extends4.default)({}, state[getKey(key, 'loaders')]);
      delete stateData.loaders[getLoaderKeyFromAction(opts.loaderKeys, action)];
    }
  }
}

function onStart(key, opts, state, action) {
  var _stateData;

  var type = action.type,
      actionData = (0, _objectWithoutProperties3.default)(action, ['type']); // eslint-disable-line no-unused-vars

  var _config$response = _config2.default.response,
      statusField = _config$response.statusField,
      messageField = _config$response.messageField;

  var stateData = (_stateData = {
    actionData: actionData
  }, (0, _defineProperty3.default)(_stateData, statusField, null), (0, _defineProperty3.default)(_stateData, messageField, null), (0, _defineProperty3.default)(_stateData, 'loading', true), (0, _defineProperty3.default)(_stateData, 'loaded', false), _stateData);

  updateLoaders({ state: state, stateData: stateData, key: key, opts: opts, action: action, value: true });

  if (!opts.keepOnLoad) {
    stateData.data = opts.init;
  }

  return setStateData(state, stateData, key);
}

function onSuccess(key, opts, state, action) {
  var _stateData2;

  var type = action.type,
      result = action.result,
      actionData = (0, _objectWithoutProperties3.default)(action, ['type', 'result']); // eslint-disable-line no-unused-vars

  var _config$response2 = _config2.default.response,
      statusField = _config$response2.statusField,
      messageField = _config$response2.messageField,
      dataField = _config$response2.dataField;

  var data = opts.init;
  var stateData = (_stateData2 = {}, (0, _defineProperty3.default)(_stateData2, statusField, (0, _get3.default)(action, ['result', statusField], null)), (0, _defineProperty3.default)(_stateData2, messageField, (0, _get3.default)(action, ['result', messageField], null)), (0, _defineProperty3.default)(_stateData2, 'actionData', actionData), (0, _defineProperty3.default)(_stateData2, 'loading', false), (0, _defineProperty3.default)(_stateData2, 'loaded', true), (0, _defineProperty3.default)(_stateData2, 'loadError', null), (0, _defineProperty3.default)(_stateData2, 'timestamp', Date.now()), _stateData2);

  if (opts.fields) {
    var fieldsData = {};
    (0, _entries2.default)(opts.fields).map(function (_ref4) {
      var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
          fldName = _ref5[0],
          val = _ref5[1];

      var formattedField = formatField(val);
      var fieldPath = formattedField.length ? ['result', dataField].concat((0, _toConsumableArray3.default)(formatField(val))) : ['result', dataField];
      var fieldData = (0, _get3.default)(action, fieldPath, opts.init[fldName]);
      fieldsData[fldName] = (0, _get3.default)(opts, ['init', fldName]) instanceof Array ? (0, _TypeCast.asArray)(fieldData) : fieldData;
    });
    if (fieldsData) {
      data = (typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) !== 'object' ? fieldsData : (0, _extends4.default)({}, data, fieldsData);
    }
  } else {
    var fieldData = (0, _get3.default)(action, ['result', dataField].concat((0, _toConsumableArray3.default)(formatField(opts.field))), opts.init);
    data = opts.init instanceof Array ? (0, _TypeCast.asArray)(fieldData) : fieldData;
  }
  stateData.data = data;

  if (opts.map) {
    (0, _entries2.default)(opts.map).map(function (_ref6) {
      var _ref7 = (0, _slicedToArray3.default)(_ref6, 2),
          field = _ref7[0],
          cb = _ref7[1];

      state[field] = cb((0, _get3.default)(action, ['result', dataField]));
    });
  }

  updateLoaders({ state: state, stateData: stateData, key: key, opts: opts, action: action, value: false });

  return setStateData(state, stateData, key);
}

function onFail(key, opts, state, action) {
  var _stateData3;

  var type = action.type,
      actionData = (0, _objectWithoutProperties3.default)(action, ['type']); // eslint-disable-line no-unused-vars

  var _config$response3 = _config2.default.response,
      statusField = _config$response3.statusField,
      messageField = _config$response3.messageField;

  var stateData = (_stateData3 = {
    data: opts.init
  }, (0, _defineProperty3.default)(_stateData3, statusField, (0, _get3.default)(action, ['result', statusField], null)), (0, _defineProperty3.default)(_stateData3, messageField, (0, _get3.default)(action, ['result', messageField], null)), (0, _defineProperty3.default)(_stateData3, 'actionData', actionData), (0, _defineProperty3.default)(_stateData3, 'loading', false), (0, _defineProperty3.default)(_stateData3, 'loaded', false), (0, _defineProperty3.default)(_stateData3, 'loadError', action.error), _stateData3);

  updateLoaders({ state: state, stateData: stateData, key: key, opts: opts, action: action, value: false });

  return setStateData(state, stateData, key);
}

function reducerFn(keys, constants) {
  var actionFunction = {};

  (0, _entries2.default)(keys).map(function (_ref8) {
    var _ref9 = (0, _slicedToArray3.default)(_ref8, 2),
        key = _ref9[0],
        opts = _ref9[1];

    var _getActionKeys2 = getActionKeys(key, opts),
        actionKey = _getActionKeys2.actionKey,
        actionKeySuccess = _getActionKeys2.actionKeySuccess,
        actionKeyFail = _getActionKeys2.actionKeyFail;

    actionFunction[constants[actionKey]] = onStart.bind(null, key, opts);
    actionFunction[constants[actionKeySuccess]] = onSuccess.bind(null, key, opts);
    actionFunction[constants[actionKeyFail]] = onFail.bind(null, key, opts);
  });

  return function (state, action) {
    return actionFunction[action.type] ? actionFunction[action.type](state, action) : state;
  };
}

exports.default = function (module, keys) {
  var _getInitial = getInitial(module, keys),
      constants = _getInitial.constants,
      constantsByKey = _getInitial.constantsByKey,
      initialState = _getInitial.initialState;

  var reducer = reducerFn(keys, constants);

  return { constants: constants, constantsByKey: constantsByKey, initialState: initialState, reducer: reducer };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/loadReducer.js
// module id = 69
// module chunks = 1